import script from "./fw24_connections.vue?vue&type=script&setup=true&lang=js"
export * from "./fw24_connections.vue?vue&type=script&setup=true&lang=js"

import "./fw24_connections.vue?vue&type=style&index=0&id=4c8208b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8208b0"]])

export default __exports__